export default "__VITE_ASSET__DbyUT9tX__"